<template>
    <div class="px-5 py-5 bg-gray">
        <h1 v-html="$t('onboarding.title')"></h1>
        <div class="pb-2">
            {{ $t('onboarding.bussinessType') }}
        </div>
        <h5 class="w-100 text-end pb-2 text-uppercase">{{ $t('onboarding.stage') }} 3/3</h5>
        <MDBCard>
            <MDBCardBody>
                <div>{{ $t('onboarding.businessRelationship') }} </div>
                <div>{{ $t('onboarding.selectRelationship') }}</div>
                <div class="py-1"><b> {{ $t('onboarding.tradingPartner') }}...</b></div>
                <div v-if="canSeeDirectRelation">
                    <input id="tradingPartnerDirect" type="radio" class="form-check-input" name="bussinessPartner"
                        value="tradingPartnerDirect" v-model="bussinessPartner" />
                    <label for="tradingPartnerDirect" class="form-check-label">{{
                        $t('onboarding.tradingPartnerDirect')
                    }}</label>
                </div>
                <div>
                    <input id="tradingPartnerIndirect" type="radio" class="form-check-input" name="bussinessPartner"
                        value="tradingPartnerIndirect" v-model="bussinessPartner" />
                    <label for="tradingPartnerIndirect" class="form-check-label">{{
                        $t('onboarding.tradingPartnerIndirect')
                    }} </label>
                </div>
                <div v-if="cannotSeeBothRelation">
                    <input id="tradingPartnerBoth" type="radio" class="form-check-input" name="bussinessPartner"
                        value="tradingPartnerBoth" v-model="bussinessPartner" />
                    <label for="tradingPartnerBoth" class="form-check-label">{{
                        $t('onboarding.tradingPartnerBoth')
                        }} </label>
                </div>

                <div
                    v-if="bussinessPartner === 'tradingPartnerDirect' || bussinessPartner === 'tradingPartnerBoth' || bussinessPartner === 'fleetResponsibleDirect' || bussinessPartner === 'fleetResponsibleBoth'">
                    <div class="py-1"><b>{{ $t('account.profile.bsClientNr') }}<sup>*</sup>:</b></div>
                    <div><input type="text" pattern="[0-9]" required minlength="6" maxlength="10"
                            :placeholder="$t('onboarding.enterCustomerNumber')" v-model="customerNumber"
                            :disabled="hasExistingCustomerNumber" />
                    </div>
                    <div class="text-danger" v-if="errorMessage">{{ $t("global.validation.requiredField") }}. {{
                        $t('onboarding.lengthCsNumber') }}.</div>
                    <div class="text-danger" v-if="customerNumberExistsError">{{ $t('toast.customerNumberExist') }}
                    </div>
                </div>

                <div v-if="cannotSeeFleet">
                    <div class="py-3" v-html="$t('onboarding.fleetResponsibleDirect')"></div>
                    <div v-if="canSeeDirectRelation">
                        <input id="fleetResponsibleDirect" type="radio" class="form-check-input"
                            name="bussinessPartner" value="fleetResponsibleDirect" v-model="bussinessPartner" />
                        <label for="fleetResponsibleDirect" class="form-check-label">{{
                            $t('onboarding.tradingPartnerDirect')
                            }}</label>
                    </div>
                    <div>
                        <input id="fleetResponsibleIndirect" type="radio" class="form-check-input"
                            name="bussinessPartner" value="fleetResponsibleIndirect" v-model="bussinessPartner" />
                        <label for="fleetResponsibleIndirect" class="form-check-label">{{
                            $t('onboarding.fleetResponsibleIndirect') }}
                        </label>
                    </div>
                    <div v-if="cannotSeeBothRelation">
                        <input id="fleetResponsibleBoth" type="radio" class="form-check-input" name="bussinessPartner"
                            value="fleetResponsibleBoth" v-model="bussinessPartner" />
                        <label for="fleetResponsibleBoth" class="form-check-label">{{
                            $t('onboarding.fleetResponsibleBoth')
                            }}</label>
                    </div>
                </div>

                <div class="py-3" v-if="cannotSeeNoBussinessRelation">
                    <input id="noBusinessRelationship" type="radio" class="form-check-input"
                        name="bussinessPartner" value="noBusinessRelationship" v-model="bussinessPartner" />
                    <label for="noBusinessRelationship" class="form-check-label"
                        v-html="$t('onboarding.noBusinessRelationship')"></label>
                </div>
            </MDBCardBody>
        </MDBCard>

        <div class="w-100 d-flex justify-content-between mt-5 mb-1">
            <div>{{ $t('onboarding.required') }}</div>
            <div class="d-flex">
                <MDBBtn @click="goBack()" color="danger">{{ $t("global.buttons.back") }}</MDBBtn>
                <MDBBtn type="submit" color="danger" class="d-flex justify-content-center align-items-center"
                    :disabled="loading || !bussinessPartner" @click="onSubmit()">
                    <span>{{ $t('global.buttons.save') }}</span>
                </MDBBtn>
            </div>

        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { MDBCardBody, MDBCard, MDBBtn } from "mdb-vue-ui-kit";
import { UserService } from "@/services/user.service";
import { GroupService } from "@/services/group.service";
import { ProfileService } from "@/services/profile.service";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { useAllowDuplicatedCustomerNumber } from "@/composables/useProfileFieldCheck";

const store = useStore();
const { tenantConfig } = useTenantConfig();
const { allowDuplicatedCustomerNumber } = useAllowDuplicatedCustomerNumber(tenantConfig);
const bussinessPartner = ref(null)
const customerNumber = ref(null)
const me = computed(() => store.getters.getMe);
const initialParentAttributes = computed(() => store.getters.getInitialParentAttributes);
const allWholesalers = computed(() => store.getters.getAllWholesalers);
const loading = ref(false)
const errorMessage = ref(false)
const customerNumberExistsError = ref(false)
const selections = ref([])
const bridgestoneWholesalerIds = computed(() =>
    allWholesalers.value
        ?.filter((wholesaler) => wholesaler?.name?.trim()?.toLowerCase() === 'bridgestone')
        ?.map((wholesaler) => wholesaler.id) ?? []
)
const bridgestoneWholesalerId = computed(() => bridgestoneWholesalerIds.value[0] ?? null)
const existingCustomerNumber = computed(() =>
    me.value?.wholesalers_dealers?.find((entry) =>
        entry?.customer_number && bridgestoneWholesalerIds.value.includes(entry?.wholesaler_id)
    )?.customer_number ?? null
)
const hasExistingCustomerNumber = computed(() => !!existingCustomerNumber.value)

const storedLocale = localStorage.getItem("currentLocale");
const currentCountryCode = computed(() => storedLocale?.split('-')?.[1] ?? '');

const isRelationOptionDisabled = (disabledCodes) => {
    return disabledCodes.includes(currentCountryCode.value);
};

const canSeeDirectRelation = computed(() => !isRelationOptionDisabled(store.getters.directRelationOptionDisabled));

const cannotSeeBothRelation = computed(() => {
    return !isRelationOptionDisabled(store.getters.bothRelationOptionDisabled);
})

const cannotSeeFleet = computed(() => {
    return !isRelationOptionDisabled(store.getters.fleetRelationOptionDisabled);
})

const cannotSeeNoBussinessRelation = computed(() => {
    return !isRelationOptionDisabled(store.getters.noBussinesRelationOptionDisabled);
})

watch(
    existingCustomerNumber,
    (value) => {
        if (value) {
            customerNumber.value = value
        }
    },
    { immediate: true }
)

watch(customerNumber, () => {
    customerNumberExistsError.value = false
})

onMounted(async () => {
    if (!allWholesalers.value?.length) {
        await store.dispatch("loadWholeSalers")
    }
})

const goBack = async () => {
    loading.value = true
    const data = {
        id: me.value.id,
        intro: 2,
    };
    await ProfileService.updateUserLiteIntro(data);
    await store.dispatch("me");

    loading.value = false
}

const onSubmit = async () => {
    customerNumberExistsError.value = false

    let showCsnumber = bussinessPartner.value === 'tradingPartnerDirect' ||
        bussinessPartner.value === 'tradingPartnerBoth' ||
        bussinessPartner.value === 'fleetResponsibleDirect' ||
        bussinessPartner.value === 'fleetResponsibleBoth'

    const isDigit = /^\d+$/.test(customerNumber.value)
    const lengthCheck = customerNumber.value && (customerNumber.value.length < 6 || customerNumber.value.length > 10)

    if ((!customerNumber.value && showCsnumber) || (!isDigit && customerNumber.value) || lengthCheck) {
        errorMessage.value = true
    } else {
        errorMessage.value = false
        loading.value = true

        if (customerNumber.value && showCsnumber && !hasExistingCustomerNumber.value) {
            const csNrData = {
                customer_number: customerNumber.value,
                dealer_id: me.value.plainId,
                id: null,
                can_be_duplicated: allowDuplicatedCustomerNumber(),
                wholesaler_id: bridgestoneWholesalerId.value
            };

            const responseCsNr = await UserService.saveCustomerNumber(csNrData);

            if (responseCsNr?.data?.message === "exists") {
                customerNumberExistsError.value = true
                loading.value = false
                return
            }
        }

        selections.value.push(bussinessPartner.value)

        store.dispatch('addInitialParentAttributes', {
            user_id: me.value.id,
            options: initialParentAttributes.value.options,
            selection: selections.value
        });

        let input = {
            user_id: me.value.plainId,
            options: initialParentAttributes.value.options,
            selection: initialParentAttributes.value.selection
        }

        await GroupService.parentAttributeAsignSelector(input)
        const data = {
            id: me.value.id,
            intro: 0,
        };
        await ProfileService.updateUserLiteIntro(data);
        await store.dispatch("me");
        await store.dispatch('fetchTenantPermissions', true)
        await store.dispatch("loadUserSlides");
        await store.dispatch("loadDealerApps");
        loading.value = false

        store.dispatch('addInitialParentAttributes', []);
        store.dispatch('displayInitialSurvey', 0)

    }
}
</script>
